import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/style/index.css";
import elementAppearBubble from "./directives/elementAppearBubble";

const app = createApp(App);

// 注册全局指令
app.directive("element-appear-bubble", elementAppearBubble);

app.use(router);
app.mount("#app");
